const IconNotifications = ({ className }) => {
    return (
        <svg width='29' height='31' viewBox='0 0 29 31' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M1 7V27.904C1 28.8745 2.24335 29.2761 2.81106 28.489L7.15132 22.4712C7.52726 21.9499 8.13077 21.6411 8.77344 21.6411H22C25.3137 21.6411 28 18.9548 28 15.6411V7C28 3.68629 25.3137 1 22 1H7C3.68629 1 1 3.68629 1 7Z'
                stroke='white'
                strokeWidth='2'
                strokeLinecap='round'
                className={className}
            />
            <path
                d='M11 12C11 13.1046 10.1046 14 9 14C7.89543 14 7 13.1046 7 12C7 10.8954 7.89543 10 9 10C10.1046 10 11 10.8954 11 12Z'
                fill='white'
            />
            <path
                d='M17 12C17 13.1046 16.1046 14 15 14C13.8954 14 13 13.1046 13 12C13 10.8954 13.8954 10 15 10C16.1046 10 17 10.8954 17 12Z'
                fill='white'
            />
            <path
                d='M23 12C23 13.1046 22.1046 14 21 14C19.8954 14 19 13.1046 19 12C19 10.8954 19.8954 10 21 10C22.1046 10 23 10.8954 23 12Z'
                fill='white'
            />
        </svg>
    );
};

export default IconNotifications;
